import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../common/customfunctions';
import tableDragger from 'table-dragger';
import { WorkflowAPIModel } from './workflow-model';
import { ApiMethod } from '../apimethods/api-method';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.css']
})

/** workflow component*/
export class WorkflowComponent implements OnInit {
  modelItem = new WorkflowAPIModel;

  @ViewChild('dataTable') table;

  showModal: boolean;
  infoModal: boolean;
  title: string;
  popUpButtonText: string;
  workflowID: number;
  workflowName: string;
  description: string;
  count: string;
  SrNo: string;
  status: boolean = false;

  dataTable: any;
  dataSet: any;
  journalList: any;
  articleTypeList: any;
  articleList: any;
  issueList: any;
  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <WorkflowAPIModel>data["WorkflowPage"];
        $('.select2').select2({ dropdownParent: "#workflowDetails" });

        this.GetWorkflowList();

        localStorage.aEID = 0;
        localStorage.ActivityNo = "";

        $('#lstJournals').select2({
          placeholder: "Select Journal",
          dropdownParent: "#workflowDetails"
        });
        $('#lstJournals').val([]).trigger('change');

        $('#lstArticleTypes').select2({
          placeholder: "Select Article Type",
          dropdownParent: "#workflowDetails"
        });
        $('#lstArticleTypes').val([]).trigger('change');

        $('#lstArticles').select2({
          placeholder: "Select Article",
          dropdownParent: "#workflowDetails"
        });
        $('#lstArticles').val([]).trigger('change');

        $('#lstIssue').select2({
          placeholder: "Select Issue",
          dropdownParent: "#workflowDetails"
        });
        $('#lstIssue').val([]).trigger('change');

        $('#Journallst').select2({
          placeholder: "Select Journal",
          dropdownParent: "#workflowDetails"
        });
        $('#Journallst').val([]).trigger('change');

        this.GetJournalsList();
        this.GetArticleTypeList();

        $('#divArticle').show();
        $('#divArticleType').parent().show();
        $('#divIssue').hide();
        this.count = "0";
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngAfterViewChecked(): void {
    this.UpdateTableHeight();
  }
  UpdateTableHeight() {
    $('.activityTable').css('height', GlobalConstants.size.height - 150);
  }

  GetWorkflowList() {
    $("#LoadingImage").show();
    var workflowData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.WorkflowAPI, workflowData).subscribe(
      result => {
        $("#LoadingImage").hide();

        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'WorkflowModule';

        dataItem.isDefault = true;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  Show() {


    if (localStorage.aEID != 0) {
      $("#LoadingImageReopen").show();
      var workflowData = {
        LoginId: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        WorkflowId: localStorage.aEID
      };

      ApiMethod.postMethod(this.modelItem.WorkflowDetailsAPI, workflowData).subscribe(
        response => {
          this.workflowName = response.workflowDetails.Details.WorkFlowName;
          this.description = response.workflowDetails.Details.Description;
          $('#Txt_Description').val(response.workflowDetails.Details.Description);
          $('#Txt_WorkFlow').val(response.workflowDetails.Details.WorkFlowName);
          this.workflowID = response.workflowDetails.Details.ID;
          localStorage.aEID = response.workflowDetails.Details.ID;

          //JournalList
          var data = response.workflowDetails.Details.JournalList.split(',');
          var selectedValues = new Array();

          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#lstJournals').val(selectedValues).change();

          if (response.workflowDetails.Details.WorkflowType === "Article") {
            $('#lstWorkflowType').val('Article');
            $('#divArticle').show();
            $('#divArticleType').parent().show();
            $('#divIssue').hide();

            data = response.workflowDetails.Details.ArticleTypeList.split(',');
            selectedValues = new Array();

            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = parseInt(data[i]);
              }
            } catch (e) {
            }
            $('select#lstArticleTypes').val(selectedValues).change();

            var selectArticle = $('#workflowDetails').find('#lstArticles');
            selectArticle.html('');
            var zArticleList = '';
            var articles = response.workflowDetails.Details.ArticleList;
            var selectedArticles = response.workflowDetails.SelectedArticleList;
            $.each(selectedArticles, (e, selectedArticle) => {
              var ind = -1;
              if (articles != null || articles != '')
                ind = articles.indexOf(selectedArticle.ID);

              if (ind >= 0)
                zArticleList += '<option selected value="' + selectedArticle.ID + '" >' + selectedArticle.ArticleTitle + '</option>';
            });

            $.each(response.workflowDetails.ArticleList, (e, article) => {
              var index = -1;
              if (articles != null || articles !== '')
                index = articles.indexOf(article.ID);

              if (index >= 0)
                zArticleList += '<option selected value="' + article.ID + '" >' + article.ArticleTitle + '</option>';
              else
                zArticleList += '<option value="' + article.ID + '" >' + article.ArticleTitle + '</option>';
            });
            selectArticle.html(zArticleList);
          }
          else {
            $('#lstWorkflowType').val('Issue');
            $('#divArticle').hide();
            $('#divArticleType').parent().hide();
            $('#divIssue').show();

            var selectIssue = $('#workflowDetails').find('#lstIssue');
            selectIssue.html('');
            var zIssueList = '';
            zIssueList += '<option value="0" disabled selected>Select Issue</option>';
            var issueId = parseInt(response.workflowDetails.Details.ArticleList);
            var iId = response.workflowDetails.Details.ArticleList;
            var id = 0;
            var textValue = "";
            var index = -1;
            var arr = [];

            $.each(response.workflowDetails.SelectedIssueList, (e, selectedIssue) => {
              if (selectedIssue.ID === issueId) {
                id = selectedIssue.ID;
                textValue = selectedIssue.Volume + '-' + selectedIssue.Issue;
              }
              arr.push(selectedIssue.ID);
            });

            index = arr.join(',').indexOf(iId);

            $.each(response.workflowDetails.IssueList, (e, issue) => {
              if (index >= 0) {
                zIssueList += '<option selected value="' + id + '">' + textValue + '</option>';
                index = -1;
              } else if (issue.ID == issueId)
                zIssueList += '<option selected value="' + issue.ID + '">' + issue.Volume + '-' + issue.Issue + '</option>';
              else {
                zIssueList += '<option value="' + issue.ID + '">' + issue.Volume + '-' + issue.Issue + '</option>';
              }
            });
            selectIssue.html(zIssueList);
          }

          $("#tblAddWFList tbody").html("");
          var nRowL = "";
          var workflowItems = response.workflowDetails.AItemList;
          for (var i = 0; i < workflowItems.length; i++) {
            nRowL += "<tr id='tr_" + (i + 1).toString() + "'><td>" + (i + 1).toString() + "</td>";
            nRowL += "<td id='act_" + (i + 1).toString() + "' data-id='" + workflowItems[i].ActivityID + "' localStorage.ActivityNo='" + (i + 1) + "'>" + workflowItems[i].Activity + "</span></td>";//Task
            nRowL += "<td data-id='" + workflowItems[i].DisplayName + "'>" + workflowItems[i].DisplayName + "</span></td>";//Display Name
            if (workflowItems[i].ParallelID != null) {
              nRowL += "<td><input type='checkbox' class='chkParallel' checked='checked' /></td>";
            }
            else {
              nRowL += "<td><input type='checkbox' class='chkParallel' " + (i === 0 ? 'disabled="disabled"' : '') + " /></td>";
            }
            nRowL += "<td><input type='text' class='form-control IsNumeric' value='" + workflowItems[i].Days + "'/></td>";
            nRowL += "<td><input type='text' class='form-control IsNumeric' value='" + workflowItems[i].Hours + "'/></td>";

            nRowL += "<td style='text-align: center'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.ActivityNo='" + (i + 1).toString() + "';$('#btnDeleteActivity').trigger('click');></i></td>";
            nRowL += "</tr>";
          }

          $("#tblAddWFList tbody").append(nRowL);

          $("input.IsNumeric").keydown(e => {
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
              return;
            }
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
              e.preventDefault();
            }
          });

          var el = document.getElementById('tblAddWFList');
          var dragger = tableDragger(el, {
            mode: 'row',
            dragHandler: '',
            onlyBody: true,
            animation: 500
          });
          dragger.on('drop', (from, to) => {
            $("table#tblAddWFList tbody").each(function (ind) {
              $(this).children().each(function (index) {
                if (index === 0) {
                  $(this).find('td .chkParallel').attr("disabled", "disabled");
                  $(this).find('td .chkParallel').removeAttr("checked");
                }
                else
                  $(this).find('td .chkParallel').removeAttr("disabled");

                $(this).find('td').first().html((index + 1).toString());

                $(this).find('td:nth-child(2)').attr("id", "act_" + (index + 1).toString());
                $(this).find('td:nth-child(2)').find('select').attr("id", "act_" + (index + 1).toString());

                //var UploadDownloadHtml = "<span class=spDTIcon>"
                //  + "<i class='fa fa-download' title='Download' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDownloadDT').trigger('click');></i>"
                //  + "<i class='fa fa-upload' title='Upload' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnUploadDT').trigger('click');></i>"
                //  // "<input type='text' class='form-control hide' id='TxtFile_" + (index + 1).toString() + "'></span>"
                //  + "</span>";
                //var linkButton = "<span class='spDTIcon'><button type='button' class='btn btn-primary btnsecondary' style='padding:5px' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnLink').trigger('click');>Link File</button></span>"
                //$(this).find('td:nth-child(9)').first().html(linkButton);

                var deleteHtml = "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'"
                  + "onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDeleteActivity').trigger('click');></i>";

                $(this).find('td:nth-child(8)').first().html(deleteHtml);

                $("#act_" + (index + 1)).closest("tr").attr("id", "tr_" + (index + 1).toString());
              });
            });
          });
          $("#LoadingImageReopen").hide();
        }, error => {
          $("#LoadingImageReopen").hide();
          ngswal("Failed !", error.message, "warning");
        });
      this.popUpButtonText = "Update";
    } else {
      $('#divArticle').show();
      $('#divArticleType').parent().show();
      $('#divIssue').hide();

      $('#lstWorkflowType').val('Article');
      this.workflowID = 0;
      this.workflowName = "";
      this.description = "";
      $("#tblAddWFList tbody").html("");

      this.popUpButtonText = "Save";
    }
    this.title = "Workflow Details";    // Dynamic Data
    this.showModal = true;


  }

  Delete() {
    ngswal({
      title: this.modelItem.DeleteTitle,
      text: this.modelItem.DeleteText,
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  DeleteConfirm() {
    $('#LoadingImage').show();

    ApiMethod.getMethod(this.modelItem.DeleteWorkflow + '/' + localStorage.aEID + '/' + localStorage.aLoginID).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Deleted !",
            text: result.message + ' ?',
            showConfirmButton: false,
            timer: 1500
          });
          this.GetWorkflowList();
        } else {
          ngswal("Failed !", this.modelItem.FailedMsg, "warning");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  hide() {
    this.showModal = false;
    this.infoModal = false;

    $("#lstJournals").val(0).change();
    $("#lstArticleTypes").val(0).change();
    $("#lstArticles").val(0).change();
    $("#lstIssue").val(0).change();

    $("input[type='text']").val('');
    $('#Txt_Description').val('');
  }

  AddActivity() {
    if (this.validate()) {
      var aJournalList = "0"; var aArticleList = "0";
      if ($('#lstJournals').val() != null) {
        aJournalList = $('#lstJournals').val().toString();
      }
      if ($('#lstArticles').val() != null) {
        aArticleList = $('#lstArticles').val().toString();
      }

      var workflowData = {
        JournalList: aJournalList,
        ArticleList: aArticleList
      };

      ApiMethod.postMethod(this.modelItem.DropdownValues, workflowData).subscribe(
        result => {
          this.count = (parseInt(this.count) + 1).toString();

          var zRowLenth = $("#tblAddWFList").find("tr").length;

          var zActList = '<select class="form-control txtactivity select2" id="act_' + zRowLenth.toString() + '" onchange=localStorage.ActivityNo="' + zRowLenth.toString()
            + '";$("#btnCheckActivity").trigger("click");>';
          zActList += '<option value="0" disabled selected>Select Activity</option>';
          $.each(result.aitemActivityList, (e, val) => {
            zActList += '<option value="' + val.Activity + '">' + val.Activity + '</option>';
          });
          zActList += '</select>';

          var zBucketList = '<select class="form-control select2" id="bucket_' + zRowLenth.toString() + '">';
          zBucketList += '<option disabled selected value="0">Select bucket Name</option>';
          $.each(result.aIngestionsBuckets, (e, bucket) => {
            zBucketList += '<option style="width:120px;" value="' + bucket.PackageModule + '/' + bucket.ActionType + '">' + bucket.PackageModule + '/' + bucket.ActionType + '</option>';
          });
          zBucketList += '</select>';

          //var zStageList = '<select class="form-control select2" id="stage_' + zRowLenth.toString() + '">';
          //zStageList += '<option style="width:120px;"value="0"data-id="0">Select Stage</option>';
          //$.each(this.stagingList, function (e, stage) {
          //  zStageList += '<option style="width:120px;" value="' + stage.Name + '" data-id="' + stage.ID + '">' + stage.Name + '</option>';
          //});
          //zStageList += '</select>';

          var nRowL = "<tr id='tr_" + zRowLenth + "'><td>" + zRowLenth.toString() + "</td>"
            + "<td>" + zActList + "</td>"
            + "<td><input type='text' class='form-control' id='DispName_" + zRowLenth.toString() + "'/></td>"
            + "<td><input type='checkbox' class='chkParallel' " + (zRowLenth === 1 ? 'disabled="disabled"' : '') + " /></td>"
            + "<td><input type='text' class='form-control TxtDays IsNumeric' id='txt_Days'></td>"
            + "<td><input type='text' class='form-control TxtHours IsNumeric' id='txt_Hours'></td>"
            //+ "<td width='15%'>" + zBucketList + "</td>"
            //+ "<td width='15%'>" + zStageList + "</td>"
            //+ "<td><span class=spDTIcon>"
            //+ "<i class='fa fa-download' title='Download' onclick=localStorage.ActivityNo='" + zRowLenth + "';$('#btnDownloadDT').trigger('click');></i>"
            //+ "<i class='fa fa-upload' title='Upload' onclick=localStorage.ActivityNo='" + zRowLenth + "';$('#btnUploadDT').trigger('click');></i>"
            //// "<input type='text' class='form-control hide' id='TxtFile_" + zRowLenth + "'></span></td>"
            //+ "</span></td>"
            //+ "<td><span class='SpDTIcon'>"
            //+ "<button type='button' class='btn btn-primary btnsecondary' style='padding:5px' onclick=localStorage.ActivityNo='" + zRowLenth + "';$('#btnLink').trigger('click');>Link File</button></span>"
            //+ "<td><input type='checkbox' class='chkMilestone' /></td>"
            + "<td style='text-align: center'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.ActivityNo='" + zRowLenth.toString() + "';$('#btnDeleteActivity').trigger('click');></i></td>"
            + "</tr>";

          $("#tblAddWFList tbody").append(nRowL);

          $("input.IsNumeric").keydown(e => {
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
              return;
            }
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
              e.preventDefault();
            }
          });

          var el = document.getElementById('tblAddWFList');
          var dragger = tableDragger(el, {
            mode: 'row',
            dragHandler: '',
            onlyBody: true,
            animation: 500
          });
          dragger.on('drop', (from, to) => {
            $("table#tblAddWFList tbody").each(function (ind) {
              $(this).children().each(function (index) {
                if (index === 0) {
                  $(this).find('td .chkParallel').attr("disabled", "disabled");
                  $(this).find('td .chkParallel').removeAttr("checked");
                }
                else
                  $(this).find('td .chkParallel').removeAttr("disabled");

                $(this).find('td').first().html((index + 1).toString());

                $(this).find('td:nth-child(2)').attr("id", "act_" + (index + 1).toString());
                $(this).find('td:nth-child(2)').find('select').attr("id", "act_" + (index + 1).toString());

                //var UploadDownloadHtml = "<span class=spDTIcon>"
                //  + "<i class='fa fa-download' title='Download' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDownloadDT').trigger('click');></i>"
                //  + "<i class='fa fa-upload' title='Upload' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnUploadDT').trigger('click');></i>"
                //  // "<input type='text' class='form-control hide' id='TxtFile_" + (index + 1).toString() + "'></span>"
                //  + "</span>"
                //var linkButton = "<span class='spDTIcon'><button type='button' class='btn btn-primary btnsecondary' style='padding:5px' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnLink').trigger('click');>Link File</button></span>";
                //$(this).find('td:nth-child(9)').first().html(linkButton);

                var deleteHtml = "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'"
                  + "onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDeleteActivity').trigger('click');></i>";

                $(this).find('td:nth-child(8)').first().html(deleteHtml);

                $("#act_" + (index + 1)).closest("tr").attr("id", "tr_" + (index + 1).toString());
              });
            });
          });
          //$('.select2').select2({ dropdownParent: "#workflowDetails" });
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }

  DeleteActivity() {
    this.count = (parseInt(this.count) + 1).toString();
    $("#act_" + localStorage.ActivityNo).closest("tr").remove();

    $("table#tblAddWFList tbody").each(function (ind) {
      $(this).children().each(function (index) {
        if (index === 0) {
          $(this).find('td .chkParallel').attr("disabled", "disabled");
          $(this).find('td .chkParallel').removeAttr("checked");
        }
        else
          $(this).find('td .chkParallel').removeAttr("disabled");

        $(this).find('td').first().html((index + 1).toString());

        $(this).find('td:nth-child(2)').attr("id", "act_" + (index + 1).toString());
        $(this).find('td:nth-child(2)').find('select').attr("id", "act_" + (index + 1).toString());

        //var UploadDownloadHtml = "<span class=spDTIcon>"
        //  + "<i class='fa fa-download' title='Download' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDownloadDT').trigger('click');></i>"
        //  + "<i class='fa fa-upload' title='Upload' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnUploadDT').trigger('click');></i>"
        //  // "<input type='text' class='form-control hide' id='TxtFile_" + (index + 1).toString() + "'></span>"
        //  + "</span>";
        //var linkButton = "<span class='spDTIcon'><button type='button' class='btn btn-primary btnsecondary' style='padding:5px' onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnLink').trigger('click');>Link File</button></span>";
        //$(this).find('td:nth-child(9)').first().html(linkButton);

        var deleteHtml = "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'"
          + "onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDeleteActivity').trigger('click');></i>";

        $(this).find('td:nth-child(8)').first().html(deleteHtml);

        $("#act_" + (index + 1)).closest("tr").attr("id", "tr_" + (index + 1).toString());
      });
    });

    var el = document.getElementById('tblAddWFList');
    var dragger = tableDragger(el, {
      mode: 'row',
      dragHandler: '',
      onlyBody: true,
      animation: 500
    });
    dragger.on('drop', function (from, to) {
      $("table#tblAddWFList tbody").each(function (ind) {
        $(this).children().each(function (index) {
          if (index === 0) {
            $(this).find('td .chkParallel').attr("disabled", "disabled");
            $(this).find('td .chkParallel').removeAttr("checked");
          }
          else
            $(this).find('td .chkParallel').removeAttr("disabled");

          $(this).find('td').first().html((index + 1).toString());

          $(this).find('td:nth-child(2)').attr("id", "act_" + (index + 1).toString());
          $(this).find('td:nth-child(2)').find('select').attr("id", "act_" + (index + 1).toString());

          var deleteHtml = "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'"
            + "onclick=localStorage.ActivityNo='" + (index + 1) + "';$('#btnDeleteActivity').trigger('click');></i>";

          $(this).find('td:nth-child(8)').first().html(deleteHtml);

          $("#act_" + (index + 1)).closest("tr").attr("id", "tr_" + (index + 1).toString());
        });
      });
    });
  }

  AddUpdateWorkFlow() {
    var isValid = this.validate();
    if (!isValid)
      return false;

    $("#LoadingImageReopen").show();

    var getWorkflowList = [];
    getWorkflowList = GlobalConstants.GetTableRowToList('tblAddWFList', null);

    if (getWorkflowList.length === 0) {
      ngswal("Warning !", this.modelItem.WorkflowActivityErrorMsg, "warning");
      $("#LoadingImageReopen").hide();
      return false;
    }

    for (var i = 0; i < getWorkflowList.length; i++) {
      getWorkflowList[i] = getWorkflowList[i].toString();
    }

    var ids = "";
    if ($('#lstWorkflowType').val() === "Article") {
      if ($('#lstArticles').val() != null) {
        ids = $('#lstArticles').val().toString();
      }
    }
    else {
      if ($('#lstIssue').val() != null) {
        ids = $('#lstIssue').val().toString();
      }
    }

    var _journalList = "0"; var _articleTypeList = "0";
    if ($('#lstJournals').val() != null) {
      _journalList = $('#lstJournals').val().toString();
    }
    if ($('#lstArticleTypes').val() != null) {
      _articleTypeList = $('#lstArticleTypes').val().toString();
    }
    var data = {
      Id: localStorage.aEID,
      WorkflowName: $('#Txt_WorkFlow').val(),
      JournalList: _journalList,
      ArticleTypeList: _articleTypeList,
      ArticleList: ids,
      PublisherId: localStorage.aPubID,
      WorkflowType: $('#lstWorkflowType').val(),
      Description: $('#Txt_Description').val(),
      AccessList: getWorkflowList,
      CreatedBy: localStorage.aLoginID,
      UpdatedBy: localStorage.aLoginID
    };

    ApiMethod.postMethod(this.modelItem.WorkflowUpdate, data).subscribe(
      response => {
        if (response.status === "success") {
          this.hide();
          this.GetWorkflowList();

          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
        } else if (response.status === "duplicate") {
          ngswal("Warning !", response.message, "warning");
        } else {
          ngswal("Warning !", this.modelItem.FailedMsg, "warning");
        }
        $("#LoadingImageReopen").hide();
      },
      error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImageReopen").hide();
      });
  }

  CheckActivity() {
    var zChkVal = true;
    $.each($("#tblAddWFList tbody tr"), function (e) {
      var zPreVal = $(this).find('td')[1].innerText;
      if ($(this).find('td').find('select').length > 0 && (e !== $("#tblAddWFList tbody tr").length - 1)) {
        zPreVal = $(this).find('td').find('select').val().toString();
      }
      if (zPreVal === $("#act_" + localStorage.ActivityNo + " option:selected").text()) {
        ngswal("Warning !", "Already Activity Added!", "warning");
        zChkVal = false;
      }
      if (zChkVal) {
        $("#DispName_" + localStorage.ActivityNo).val($("#act_" + localStorage.ActivityNo + " option:selected").text());
        return true;
      } else {
        $("#act_" + localStorage.ActivityNo).val(0).change();
        $("#DispName_" + localStorage.ActivityNo).val('');
        return false;
      }
    });
  }

  validate() {
    var aResultL = true;
    $("table#tblAddWFList tbody").each(function () {
      $(this).children().each(function (index) {
        var lastActivity = $(this).find('select').val();

        if ($(this).find('select').length > 0 && lastActivity === "0") {
          ngswal("Warning !", "Select Activity !", "warning");
          aResultL = false;
        } else if ($(this).find('#txt_DisplayName').length > 0 && $(this).find('#txt_DisplayName').val() === "") {
          ngswal("Warning !", "Enter Display Name !", "warning");
          aResultL = false;
        } else if ($(this).find('#txt_Days').length > 0 && $(this).find('#txt_Days').val() === "") {
          ngswal("Warning !", "Enter days !", "warning");
          aResultL = false;
        } else if ($(this).find('#txt_Hours').length > 0 && $(this).find('#txt_Hours').val() === "") {
          ngswal("Warning !", "Enter Hours !", "warning");
          aResultL = false;
        }
      });
    });

    if (aResultL) {
      var aActivityList = $($("#tblAddWFList").find("tr")).find('.txtactivity');
      $.each(aActivityList, function () {
        if ($(this).val() === "") {
          ngswal("Warning !", "Select Activity !", "warning");
          aResultL = false;
          return false;
        }
      });
    }

    if (aResultL) {
      if ($('#Txt_WorkFlow').val() === "") {
        ngswal("Warning !", this.modelItem.WorkflowErrorMsg, "warning");
        aResultL = false;
      }
      //else if ($('#lstPublisher').val() == "0" || $('#lstPublisher').val() == null) {
      //  ngswal("Warning !", this.modelItem.PublisherErrorMsg, "warning");
      //  aResultL = false;
      //}
      //else if ($('#Txt_Description').val() === "") {
      //  ngswal("Warning !", this.modelItem.DescriptionErrorMsg, "warning");
      //  aResultL = false;
      //}
      else if (this.CheckWorkflow($('#Txt_WorkFlow').val())) {
        $('#Txt_WorkFlow').val('');
        ngswal("Warning !", this.modelItem.DuplicateWorkflowErrorMsg, "warning");
        aResultL = false;
      } else if ($('#lstJournals').val() === "") {
        $('#lstJournals').val('');
        ngswal("Warning !", "Select Journals", "warning");
        aResultL = false;
      }
    }
    return aResultL;
  }

  onSearchChange(event): void {
    this.CheckWorkflow(event.currentTarget.value);
  }

  CheckWorkflow(searchValue) {
    var workflowText = '';
    if (searchValue === '')
      workflowText = $('#Txt_WorkFlow').val();
    else
      workflowText = searchValue;

    var workflowData = {
      WorkflowName: workflowText,
      Id: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.CheckDuplicate, workflowData).subscribe(
      response => {
        if (response.status === "Duplicate") {
          this.status = true;
          $('#Txt_WorkFlow').val('');
          ngswal("Failed !", response.message, "warning");
          return this.status;
        } else {
          this.status = false;
          return this.status;
        }
      }, error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImage").hide();
      });
    return this.status;
  }

  Info() {
    var workflowData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      WorkflowId: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.WorkflowDetailsAPI, workflowData).subscribe(
      response => {
        this.workflowName = response.workflowDetails.Details.WorkFlowName;
        this.description = response.workflowDetails.Details.Description;
        this.workflowID = response.workflowDetails.Details.ID;
        localStorage.aEID = response.workflowDetails.Details.ID;

        var data = response.workflowDetails.Details.JournalList.split(',');
        var selectedValues = new Array();

        try {
          for (var i = 0; i < data.length; i++) {
            selectedValues[i] = data[i];
          }
        } catch (e) {
        }
        $('#workflowInfo').find('#Journallst').val(selectedValues).change();

        if (response.workflowDetails.Details.WorkflowType === "Article") {
          $('#WorkflowTypelst').val('Article');
          $('#ArticleDiv').show();
          $('#ArticleTypeDiv').parent().show();
          $('#IssueDiv').hide();

          var data = response.workflowDetails.Details.ArticleTypeList.split(',');
          var selectedValues = new Array();

          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = parseInt(data[i]);
            }
          } catch (e) {
          }
          $('select#ArticleTypelst').val(selectedValues).change();

          var selectArticle = $('#workflowInfo').find('#Articlelst');
          selectArticle.html('');
          var zArticleList = '';
          var articles = response.workflowDetails.Details.ArticleList;
          $.each(response.workflowDetails.ArticleList, (e, article) => {
            var index = -1;
            if (articles != null || articles !== '')
              index = articles.indexOf(article.ID);

            if (index >= 0)
              zArticleList += '<option selected value="' + article.ID + '" >' + article.ArticleTitle + '</option>';
            else
              zArticleList += '<option value="' + article.ID + '" >' + article.ArticleTitle + '</option>';
          });
          selectArticle.html(zArticleList);
        }
        else {
          $('#WorkflowTypelst').val('Issue');
          $('#ArticleDiv').hide();
          $('#ArticleTypeDiv').parent().hide();
          $('#IssueDiv').show();

          var selectIssue = $('#workflowInfo').find('#Issuelst');
          selectIssue.html('');
          var zIssueList = '';
          zIssueList += '<option value="0" disabled selected>Select Issue</option>';
          var issueId = parseInt(response.workflowDetails.Details.ArticleList);
          $.each(response.workflowDetails.IssueList, (e, issue) => {
            if (issue.ID === issueId)
              zIssueList += '<option selected value="' + issue.ID + '">' + issue.Volume + '-' + issue.Issue + '</option>';
            else
              zIssueList += '<option value="' + issue.ID + '">' + issue.Volume + '-' + issue.Issue + '</option>';
          });
          selectIssue.html(zIssueList);
        }

        var workflowItems = response.workflowDetails.AItemList;

        $("#tblWorkflowActivities tbody").html("");
        var nRowL = "";
        for (var i = 0; i < workflowItems.length; i++) {
          nRowL += "<tr><td>" + (i + 1).toString() + "</td>";
          nRowL += "<td>" + workflowItems[i].Activity + "</td>";//Task
          nRowL += "<td>" + workflowItems[i].DisplayName + "</td>";//Display Name
          if (workflowItems[i].ParallelID != null) {
            nRowL += "<td><input type='checkbox' class='chkParallel' checked='checked' disabled/></td>";
          }
          else {
            nRowL += "<td><input type='checkbox' class='chkParallel' disabled/></td>";
          }
          nRowL += "<td>" + workflowItems[i].Days + "</td>";
          nRowL += "<td>" + workflowItems[i].Hours + "</td>";
          //if (workflowItems[i].bucketName == null)
          //  nRowL += "<td width='15%;'></td>";//Proofing Name
          //else
          //  nRowL += "<td width='15%;'>" + workflowItems[i].bucketName + "</td>";//Proofing Name
          //if (workflowItems[i].Stage == null)
          //  nRowL += "<td width='15%;'></td>";//Stage
          //else
          //  nRowL += "<td width='15%;'>" + workflowItems[i].Stage + "</td>";//Stage
          //nRowL += "<td><span class='spDTIcon'></span></td>";
          //if (workflowItems[i].Milestone == 1)
          //  nRowL += "<td width='50px;'><input type='checkbox' class='chkMilestone' checked='checked' disabled=disabled/></td>";
          //else
          //  nRowL += "<td width='60px;'><input type='checkbox' class='chkMilestone' disabled=disabled/></td>";
          //nRowL += "</tr>";
        }
        $("#tblWorkflowActivities tbody").append(nRowL);

        this.infoModal = true;
        this.title = "Workflow Details";

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  ChangeWorkflowType() {
    var type = $('#lstWorkflowType').val();

    if (type === 'Article') {
      $('#divArticle').show();
      $('#divArticleType').parent().show();
      $('#divIssue').hide();
    } else if (type === 'Issue') {
      $('#divIssue').show();
      $('#divArticle').hide();
      $('#divArticleType').parent().hide();
    }

    this.GetArticleIssues();

    $("#lstArticles").val(0).change();
    $("#lstIssue").val(0).change();
  }

  GetJournalsList() {
    var publisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.JournalList + '/' + publisherId + '/' + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GetArticleIssues() {
    var type = $('#lstWorkflowType').val();

    if (type === 'Article') {
      var journals = "0"; var articleType = "0";
      if ($('#lstJournals').val() != null) {
        journals = $('#lstJournals').val().toString();
      }
      if ($('#lstArticleTypes').val() != null) {
        articleType = $('#lstArticleTypes').val().toString();
      }

      ApiMethod.getMethod(this.modelItem.ArticleList + '/' + journals + '/' + articleType).subscribe(
        result => {
          this.articleList = result.articleList;
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
    else {
      if ($('#lstJournals').val() != null) {
        journals = $('#lstJournals').val().toString();
      }
      ApiMethod.getMethod(this.modelItem.IssueList + '/' + journals).subscribe(
        result => {
          this.issueList = result.issueList;
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }

  GetArticleTypeList() {
    ApiMethod.getMethod(this.modelItem.ArticleTypeList).subscribe(
      result => {
        this.articleTypeList = result.aitemArticleTypeList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }
}
